<div class='preloader preloader--full-screen bg-light-shadow center'>
    <loader></loader>
</div>
